var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{class:{'pl-0': !_vm.$vuetify.breakpoint.smAndDown}},[_c('div',{attrs:{"id":"content-start"}}),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }